// Import model
import { FilterObjectFileRequest } from '../models/FilterObjectFileRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ObjectFileCondition } from '../models/ObjectFileCondition';
import { ObjectFileFields } from '../models/ObjectFileFields';
import { ObjectFileIndexedFields } from '../models/ObjectFileIndexedFields';

// Import dependency serializers (for complex types)
import { ObjectFileConditionSerializer } from './ObjectFileConditionSerializer';
import { ObjectFileFieldsSerializer } from './ObjectFileFieldsSerializer';
import { ObjectFileIndexedFieldsSerializer } from './ObjectFileIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterObjectFileRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterObjectFileRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterObjectFileRequest instance
   */
  static deserialize(json: string): FilterObjectFileRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterObjectFileRequest instance
   */
  static fromObject(obj: any): FilterObjectFileRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterObjectFileRequest');
    }


    const instance: FilterObjectFileRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ObjectFileIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ObjectFileFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ObjectFileConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterObjectFileRequest instances
   */
  static deserializeArray(json: string): FilterObjectFileRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterObjectFileRequest instance to a JSON string
   */
  static serialize(instance: FilterObjectFileRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterObjectFileRequest instance to a plain object
   */
  static toObject(instance: FilterObjectFileRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ObjectFileConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterObjectFileRequest instances to a JSON string
   */
  static serializeArray(instances: FilterObjectFileRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
